const getters = {
  token: (state) => state.user.token,
  userInfo: (state) => state.user.userInfo,
  menus: (state) => state.menu.menus,
  menusMap: (state) => state.menu.menusMap,
  exp: (state) => state.user.exp
  // name: (state) => state.user.name,
  // is_authorizer: (state) => state.user.is_authorizer,
  // license_authorize: (state) => state.user.license_authorize,
  // wxapp_id: (state) => state.user.wxapp_id,
  // template_name: (state) => state.user.template_name,
  // login_type: (state) => state.user.login_type
}
export default getters
